export function addUrlPrefix(url) {
    const pattern = /^((http|https|ftp):\/\/)/;

    if (!pattern.test(url)) {
        return "http://" + url;
    }

    return url;
}
